import { ReactNode, useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useTitle } from 'react-use';

import NotFoundIcon from '@/components/atoms/Icons/NotFound';
import { Button } from '@/components/ui/button';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

type NotFoundProps = { entity?: string; value?: string; children?: ReactNode };

const NotFound: React.FC<NotFoundProps> = (props: NotFoundProps) => {
  const { t } = useTranslation();
  const entity = props?.entity || t('pages.page');
  const value = props?.value || '';
  useTitle(t('pages.not_found'));

  useSegments(PageName.NOT_FOUND);

  const onButtonClick = useCallback(() => {
    document.location.href = '/';
  }, []);

  return (
    <div className="mt-20 flex flex-col items-center">
      <NotFoundIcon />
      <div className="text-center text-4xl leading-11 font-medium text-foreground">
        {t('errors.not_found', { 0: entity, 1: value ? value + ' ' : '' })}
      </div>
      <div className="mt-4 text-center text-lg leading-7 font-normal">
        {t('errors.not_found_link', { 0: entity })}
      </div>
      <div className="mt-6">
        <Button onClick={onButtonClick} size="md">
          {t('error_page.return_home')}
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
